"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.success = exports.retry = exports.pending = exports.idle = exports.error = exports.done = exports.debouncing = void 0;
const done = exports.done = '@state/DONE';
const debouncing = exports.debouncing = '@state/DEBOUNCING';
const error = exports.error = '@state/ERROR';
const idle = exports.idle = '@state/IDLE';
const pending = exports.pending = '@state/PENDING';
const retry = exports.retry = '@state/RETRY';
const success = exports.success = '@state/SUCCESS';